import { render, staticRenderFns } from "./HomeCover.vue?vue&type=template&id=6c81833b&scoped=true&"
import script from "./HomeCover.vue?vue&type=script&lang=js&"
export * from "./HomeCover.vue?vue&type=script&lang=js&"
import style0 from "./HomeCover.vue?vue&type=style&index=0&id=6c81833b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c81833b",
  null
  
)

export default component.exports